import React from "react";
import ReusableModal from "components/Modals/ReusableModal";

const ArchiveFAQ = ({ isOpen, onClose, onConfirm, faq }) => {
    const bodyMessage = `Are you sure you want to archive this FAQ? This action cannot be undone.`;

    return (
        <ReusableModal
            isOpen={isOpen}
            onClose={onClose}
            onConfirm={onConfirm}
            title="Confirm Archive"
            bodyMessage={<div dangerouslySetInnerHTML={{ __html: bodyMessage }} />}
            confirmLabel="Confirm"
            cancelLabel="Cancel"
        />
    );
};

export default ArchiveFAQ;
